/**
 * The one boundary a neutral surface carries.
 *
 * A pill, a chip, a mark or a popover whose fill token is the same token as
 * the container behind it is invisible: `surface-elevated` on
 * `surface-elevated` measures 1.00, and 1.00 is the definition of "the same
 * color". The remedy is a painted frame, and the token has to be one that
 * clears WCAG 2.2 section 1.4.11's 3:1 floor for a UI component boundary
 * (`CONTRAST_FLOOR.nonText` in `packages/theme/src/contrast.ts`).
 *
 * `border-line` (`--sm-color-border`) is that token. Worst case across every
 * neutral container in either theme is 3.43, on `bg` in light. On
 * `surface-elevated` it is 3.71 light and 3.70 dark; on `surface`, 3.71 and
 * 4.09.
 *
 * `border-hairline` is NOT that token, and the design frames that draw one
 * are superseded here: it measures 1.26 light and 1.10 dark on
 * `surface-elevated`, and 1.17 and 1.32 on `bg`. It fails the floor
 * everywhere. ISSUE-615 made this same deviation for the award swatch grid
 * and measured it; ISSUE-633 applied it to the remaining seven surfaces.
 */
export const NEUTRAL_SURFACE_FRAME = "border border-line";
